<template>
    <div class="side-nav">
        <div class="side-nav-inner">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'side-nav'
    }
</script>